import * as deepMerge from 'deepmerge';
import { EventEmitter } from 'events';
import * as fastDeepEqual from 'fast-deep-equal';
import { IDataStoreFormat } from '../interfaces/DataFormats';

export enum DataStoreEvents {
	CHANGE = 'CHANGE',
	RESET = 'RESET',
}

export class DataStore<T extends IDataStoreFormat = any> extends EventEmitter {

	private _default: T;
	private _state: T;

	constructor(defaults: T) {
		super();

		this._default = deepMerge<T>({}, defaults);
		this._state = deepMerge<T>({}, this._default);
	}

	public on = (event: DataStoreEvents, listener: (state: T) => void): this => super.on(event, listener);

	public getState = (): T => deepMerge<T>({}, this._state);

	public update = (updates: Partial<T>): this => {
		const previousState = this._state;
		const nextState = deepMerge<T>(this._state, updates);

		this._state = nextState;

		if (!fastDeepEqual(previousState, nextState)) {
			this.emit(DataStoreEvents.CHANGE, this.getState());
		}

		return this;
	}

	public reset = (): this => {
		this._state = deepMerge<T>({}, this._default);

		this.emit(DataStoreEvents.RESET, this.getState());

		return this;
	}

}
